import { useAuth } from '../context/AuthContext';
import { isActiveSchoolSeat } from '../lib/school';
import { IconCheck } from './Icons';

// "You've got a school seat" banner. Shown on the home screen once, the first
// time a pupil signs in after their school assigns them a seat. Dismissal is
// stored on the seat row (seen_at) so it does not reappear on other devices.
export function SchoolSeatBanner() {
  const { schoolSeat, dismissSchoolSeatBanner } = useAuth();
  if (!isActiveSchoolSeat(schoolSeat) || schoolSeat?.seen_at) return null;

  return (
    <section className="mx-5 mt-4 rounded-2xl bg-accentSoft border border-accent/15 p-4 flex items-start gap-3">
      <span className="w-9 h-9 flex-shrink-0 rounded-full bg-accent text-white grid place-items-center">
        <IconCheck size={18} />
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-ink">You've got a school seat</p>
        <p className="mt-0.5 text-xs text-ink/65 leading-relaxed">
          {schoolSeat!.school_name} has unlocked everything for you. No limits, nothing to pay.
        </p>
      </div>
      <button
        onClick={() => void dismissSchoolSeatBanner()}
        className="flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium text-accent border border-accent/30 hover:bg-accent hover:text-white transition"
      >
        Got it
      </button>
    </section>
  );
}
